import List from '@/components/AssetsList'
import DefaultModal, { hideModal } from '@/components/Modals/ModalV2'
import ListItem from './ListItem'

const ListModal = ({ items }) => {
  return (
    <DefaultModal
      id={'list-modal'}
      title="List Modal"
      isCancelDisabled={true}
      onRetreat={() => hideModal('list-modal')}
    >
      {({ ModalBody }) => (
        <>
          <ModalBody>
            <List
              items={items}
              ItemComponent={item => <ListItem item={item} />}
            />
          </ModalBody>
        </>
      )}
    </DefaultModal>
  )
}

export default ListModal
